'use client'

export function isExternalLink(url: string): boolean {
    const invalidUrlStarting = url.startsWith('http://') || url.startsWith('https://')

    const invalidStarts = [
        'https://khanoumi.com',
        'http://khanoumi.com',
        'https://www.khanoumi.com',
        'http://www.khanoumi.com',
    ]

    const isStartingInvalid = (): boolean => {
        for (const start of invalidStarts) {
            if (url.startsWith(start)) {
                return true
            }
        }
        return false
    }

    if (invalidUrlStarting) {
        if (isStartingInvalid()) {
            return false
        }
        return true
    } else {
        return false
    }
}
